<template>
  <div>
    <div class="h-8 half_circle title-bg" />
    <div
      @click="goProfile"
      class="
        mx-2
        -mt-8
        p-2
        filter
        drop-shadow-lg
        rounded-md
        bg-white
        grid grid-rows-2 grid-flow-col
        items-center
      "
    >
      <div class="middle-text font-extrabold">
        {{ user.name }}<span><van-icon name="arrow" /></span>
      </div>
      <div class="mt-1 middle-text text-gray-400 font-semibold">
        学/工号：{{ user.id }}
      </div>
    </div>
    <div class="mx-2 mt-2 py-2 shadow-md rounded-md bg-white">
      <van-cell
        icon="completed"
        class="small-text"
        title="座位预约"
        v-if="enableSeat"
        is-link
        value="查看或取消预约"
        to="/mySeatBookings"
      />
      <van-cell
        icon="completed"
        class="small-text"
        title="研讨室预约"
        v-if="enableRoom"
        is-link
        value="查看或取消预约"
        to="/myRoomBookings"
      />
      <van-cell
        icon="completed"
        class="small-text"
        title="入馆预约"
        v-if="enableEntrance"
        is-link
        value="查看或取消预约"
        to="/myEntranceBookings"
      />
      <van-cell
        icon="failure"
        class="small-text"
        title="我的违约"
        v-if="enableViolation"
        is-link
        value="查看违约情况"
        to="/myViolations"
      />
      <van-cell v-if="sysconfig.SYS_SITE_HUODONG==1"
        icon="flag-o"
        class="small-text"
        title="我的活动"
        is-link
        value="查看参加的活动"
        to="/myEvents"
      />
      <!-- <van-cell
        icon="service-o"
        class="small-text"
        title="我的语言"
        is-link
        value="中文"
      /> -->
    </div>
    <div class="flex justify-center">
      <van-button class="m-2 w-16" round type="primary" @click="unbind()"
        >我要解绑</van-button
      >
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, toRefs } from "vue";
import { useRouter } from "vue-router";
import Cookies from "js-cookie";
import { Dialog } from "vant";
import { removeUser } from "@/service/user";
import { getSysConfig } from "@/service/home";
export default {
  name: "my",
  components: {},
  setup() {
    const userObj = JSON.parse(Cookies.get("userObj"));
    const enableRoom = JSON.parse(Cookies.get("school")).enableRoom;
    const enableSeat = JSON.parse(Cookies.get("school")).enableSeat;
    const enableEntrance = JSON.parse(Cookies.get("school")).enableEntrance;
    const enableViolation = JSON.parse(Cookies.get("school")).enableViolation;
    const dinepo = Cookies.get("dinepo");
    const router = useRouter();
    const state = reactive({
      enableRoom: enableRoom,
      enableSeat: enableSeat,
      enableEntrance : enableEntrance,
      enableViolation: enableViolation,
      user: userObj,
      sysconfig: {},
    });
    onMounted(async () => {
      state.sysconfig = await getSysConfig();
    });
    const unbind = () => {
      Dialog.confirm({
        title: "警告",
        message: "确定要解绑吗？",
      }).then(async () => {
        let { data } = await removeUser({ openid: dinepo });
        if (data.status) {
          Dialog.alert({
            title: "提示",
            message: "解绑成功！",
          }).then(() => {
            window.location.href = "/warning.html";
          });
        } else {
          Dialog.alert({
            title: "提示",
            message: "解绑失败，请重试！",
          }).then(() => {});
        }
      });
    };
    const goProfile = () => router.push("/myProfile");
    return {
      goProfile,
      unbind,
      ...toRefs(state),
    };
  },
};
</script>

<style lang="less" scoped>
@import "../common/style/base";
</style>
